import { observeScrolledPast } from '@/js/helpers/observeScrolledPast'

export class ProductBuyBar {
	public static readonly selector = '.js-product-buy-bar'

	private element: HTMLElement

	public constructor(element: HTMLElement) {
		const target = document.querySelector<HTMLElement>(`${ProductBuyBar.selector}__target`)

		if (!target) {
			throw new Error('ProductBuyBar: Missing target element.')
		}

		this.element = element

		observeScrolledPast(target, this.toggle.bind(this))

		const observer = new ResizeObserver(this.publishHeight.bind(this))
		observer.observe(this.element)
	}

	private toggle(isVisible: boolean): void {
		this.element.classList.toggle('active', isVisible)
		this.publishHeight()
	}

	private publishHeight(): void {
		if (this.element.classList.contains('active')) {
			document.documentElement.style.setProperty('--sticky-bottom-bar-height', `${this.element.offsetHeight}px`)
		} else {
			document.documentElement.style.removeProperty('--sticky-bottom-bar-height')
		}
	}
}
